import SideMenu from '@v2/shared/Layouts/SideMenu';
import SideMenuFooterLink from '@v2/shared/components/SideMenuFooterLink';
import type { FullLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';
import { INSTITUTIONAL_MENU } from './menu';

/**
 * The shell TopMags' institutional pages share — about, contact, faq, the legal documents.
 *
 * DiscountMags' Institutional layout's counterpart: the same name, the same props and the
 * same rail, resolved by brand exactly as `Layouts.Full` and `Layouts.Account` already
 * are. A page declares `layoutName = 'Layouts.Institutional'` and gets its own brand's
 * chrome without knowing which brand it is on, and draws its own breadcrumb.
 *
 * Built on Full directly rather than on a SideMenuLayout, which is what the Account layout
 * beside it does — TopMags has two side-menu layouts and DiscountMags' extra hop exists to
 * stop its own two from repeating a measure and a rhythm that Full now owns anyway. What
 * differs between the two TopMags layouts is only which list is in the rail.
 *
 * No Container and no padding here: Full draws the white card and the spacing inside it.
 */
export type InstitutionalLayoutProps = FullLayoutProps & {
  /** The menu entry to mark, as its path — `/tos`. */
  activePath?: string;
};

export default function Institutional({
  children,
  activePath,
  ...fullProps
}: InstitutionalLayoutProps) {
  return (
    <Full {...fullProps}>
      <SideMenu
        label="Customer information"
        ariaLabel="About TopMags"
        groups={INSTITUTIONAL_MENU}
        activePath={activePath}
        footer={<SideMenuFooterLink activePath={activePath} />}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
